module.exports = __webpack_public_path__ + "img/1F3F4-200D-2620-FE0F.a3fb8137.svg";